import React, { useState, useEffect } from 'react';
import { Button, Grid, Typography,IconButton} from '@mui/material';
import ReportGen from '../reports/ReportGen';
import AnnualReportCard from './AnnualReportCard';
import { useRecoilState, useRecoilValue } from 'recoil';
import {  viewedReportDataState } from '../../recoil/atoms';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import configParam from '../../config';
import CircularProgress from '@mui/material/CircularProgress';
import { userPlantState,userLocationState} from '../../recoil/atoms';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from "@mui/icons-material/Add";
import { plantId } from '../../recoil/atoms';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LinearProgress, Box} from '@mui/material';


export default function Reports() {
 
 
  const [initialOption, setInitialOption] = useState('annualrep');
  const [submittedReports, setSubmittedReports] = useState([]);
  const [viewedReportData, setViewedReportData] = useRecoilState(viewedReportDataState);
  const [selectedYear, setSelectedYear] = useState('');
  const [userDet, setUserDet] = useState({});
  const [iconsVisible, setIconsVisible] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [reportDataByYear, setReportDataByYear] = useState({});
  const [PlantId, setPlantId] = useRecoilState(plantId);
  const [, setPlantDet] = useState('');
  const [breadcrumb, setBreadcrumb] = useState('');
  const [loading, setLoading] = useState(false);
  const userPlant = useRecoilValue(userPlantState);
  const userLocation=useRecoilValue(userLocationState);
  const [, setLocationDet] = useState({});
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("Initializing...");
  const datauser=localStorage.getItem("user_id")
  let data = localStorage.getItem('user');
  let User = JSON.parse(data);
  const userlogoutdata = datauser!=null?datauser:User.plant_id[0];
  const [access_token,setAccessToken]=useState(localStorage.getItem("accesstoken"))
  const [openReportGenModal, setOpenReportGenModal] = useState(false);
  const [reportGenInitialValues, setReportGenInitialValues] = useState(null);
  const [expandedYears, setExpandedYears] = useState({customReports: true, });
  const [visibleReportsCount, setVisibleReportsCount] = useState(10);

  const ApiURL = configParam.API_URL;

  const location = useLocation();

  useEffect(() => {
    setVisibleReportsCount(10);
  }, [location.pathname]);
 
  useEffect(() => {
    // Function to check for accessToken changes
    const handleAccessTokenChange = () => {
      const storedAccessToken = localStorage.getItem("accesstoken");
      if (storedAccessToken !== access_token) {
        setAccessToken(storedAccessToken);
      }
    };
  
    // Listen for storage events (for cross-tab changes)
    window.addEventListener("storage", handleAccessTokenChange);
  
    // Check for changes every second (for same-tab changes)
    const interval = setInterval(handleAccessTokenChange, 1000);
  
    // Cleanup listeners and interval on component unmount
    return () => {
      window.removeEventListener("storage", handleAccessTokenChange);
      clearInterval(interval);
    };
  }, [access_token]); // Dependency on accessToken


  useEffect(() => {
    // Extract the last part of the current path as the breadcrumb
    const pathnames = location.pathname.split('/').filter((path) => path);
    if (pathnames.length > 1) {
      const currentBreadcrumb = pathnames[pathnames.length - 2];
      setBreadcrumb(currentBreadcrumb);
    }
    if (pathnames.length === 1) {
      const currentBreadcrumb = pathnames[pathnames.length - 1];
      setBreadcrumb(currentBreadcrumb);
    }
  }, [location]);
  useEffect(() => {
    // Set initial expanded state for year cards if available
    if (reportDataByYear.annualReports) {
      const initialYearExpandedState = {};
      Object.keys(reportDataByYear.annualReports).forEach((year) => {
        initialYearExpandedState[year] = true; // Set to true for initial expanded state
      });
  
      setExpandedYears((prevExpandedYears) => ({
        ...prevExpandedYears,
        ...initialYearExpandedState,
      }));
    }
  }, [reportDataByYear.annualReports]);
  useEffect(() => {
    setLocationDet(userLocation || {});
  }, [userLocation]);
  useEffect(() => {
setPlantDet(userPlant)
  }, [userPlant]);

  function formatBusinessName(name) {
    if (name) {
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
    return ''; // Handle the case where name is undefined or null
  }
  useEffect(() => {
    if (location.pathname === '/reports') {
      getReportDetails();
    }
  }, [location.pathname]);

  useEffect(() => {
    let data = localStorage.getItem("user");
    let User = JSON.parse(data);
    setUserDet(User);
    setViewedReportData({})
  }, []);

  useEffect(() => {
    if (userDet) {
      setIconsVisible(userDet.role_id === 3 || userDet.role_id === 1);
    }
  }, [userDet]);

  const getReportDetails = (plantName) => {
    const PlantId = plantName;
    let url = ApiURL + `/get_reports/${userlogoutdata}` ;
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
)
      .then((response) => {
        
        setSubmittedReports(response.data);
        organizeReportsByYear(response.data);
      })
      .catch((error) => {
        setSubmittedReports([]);
      });
  };
 
  const handleToggleExpand = (year) => {
    setExpandedYears((prevExpandedYears) => ({
      ...prevExpandedYears,
      [year]: !prevExpandedYears[year],
    }));
  };
  const organizeReportsByYear = (reports) => {
    const organizedData = {
      annualReports: {},
      customReports: [],
    };
  
    const sortedReports = [...reports].sort((a, b) => {
      const dateA = a.created_on ? new Date(a.created_on).getTime() : 0;
      const dateB = b.created_on ? new Date(b.created_on).getTime() : 0;
      if (dateB !== dateA) return dateB - dateA;
      return (b.id && a.id) ? b.id - a.id : 0;
    });

    sortedReports.forEach((report) => {
      const year = report.year || ''; // You can modify this logic if necessary
  
      if (report.formatted_from_date && report.formatted_to_date) {
        
        // If the report has both fromDate and toDate, consider it as a Custom Report
        organizedData.customReports.push(report);
       }else {

       
        // Otherwise, consider it as an Annual Report
        if (!organizedData.annualReports[year]) {
          organizedData.annualReports[year] = [];
        }
        organizedData.annualReports[year].push(report);
      }
    
    });
  
    setReportDataByYear(organizedData);
  };
  
 
 
  
  const handleGenerateReport = () => {
    setOpenReportGenModal(true);
    setInitialOption('annualrep');
    setSelectedYear('');
    navigate({ state: { selectedYear: selectedYear } });
  
  };
 

  const handleGenerateReportData = (reportData) => {
    if (reportData) {
      const { id, year, fromdate, todate} = reportData;
      const existingReportIndex = submittedReports.findIndex(
        (existingReport) => existingReport.id === id
      );
      if (existingReportIndex !== -1) {
        const updatedReports = [...submittedReports];
        updatedReports[existingReportIndex] = reportData;
        setSubmittedReports(updatedReports);
        organizeReportsByYear(updatedReports);
      } else {
        setSubmittedReports([...submittedReports, reportData]);
        organizeReportsByYear([...submittedReports, reportData]);
      }
      if (year) {
        // If year is present, navigate to Annual Report
        navigate(`/AnnualReport`, { state: { selectedYear: year} });
      } else if (fromdate && todate) {
        navigate(`/customreport`, { state: { selectedFromDate: fromdate, selectedToDate: todate } });
      }
      setOpenReportGenModal(true);
     
    }
  };
  



  
  

  
  const handleCardClick = (reportData) => {
   
    if (reportData.year) {
      axios.get(`${ApiURL}/get_reportsbyId/${reportData.id}`,{
        headers: {
          Authorization: `Bearer ${access_token}`,
        
        }
      }
)
        .then((response) => {
          
          const updatedReportData = {
            ...response.data[0],
            reportType: reportData.reportType,
            year: reportData.year || '',
            created_by_filter: response.data[0].created_by_filter || []
          };
          setViewedReportData(updatedReportData);
          setOpenReportGenModal(true);
          setReportGenInitialValues({
            year: updatedReportData.year,
            
            reportName: updatedReportData.report_name,
            created_by_filter: updatedReportData.created_by_filter || [],
            plant_id: updatedReportData.plant_id,
          });
          setInitialOption('annualrep');
         
        })
        .catch((error) => {
          console.error('Error fetching report data:', error);
        });
    } else {
      axios.get(`${ApiURL}/get_reportsbyId/${reportData.id}`,{
        headers: {
          Authorization: `Bearer ${access_token}`,
          
        }
      }
)
        .then((response) => {
          const updatedReportData = {
            ...response.data[0],
            reportType: reportData.reportType,
            fromdate: reportData.formatted_from_date || '',
            todate: reportData.formatted_to_date || '',
            created_by_filter: response.data[0].created_by_filter || []
          };
          setViewedReportData(updatedReportData);
          setOpenReportGenModal(true);
          setReportGenInitialValues({
            fromdate: updatedReportData.formatted_from_date,
            todate: updatedReportData.formatted_to_date,
            reportName: updatedReportData.report_name,
            created_by_filter: updatedReportData.created_by_filter || [],
            plant_id: updatedReportData.plant_id,
          });
          setInitialOption('custrep');
        })
        .catch((error) => {
          console.error('Error fetching report data:', error);
        });
    }
  };
  
  
  

  const handleDeleteReport = (reportId) => {
    axios.delete(`${ApiURL}/delete_report/${reportId}`,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
)
      .then((response) => {
        const submittedreportfilter = submittedReports.filter((report) => report.id !== reportId);
        setSubmittedReports(submittedreportfilter);
        organizeReportsByYear(submittedreportfilter);
      })
      .catch((error) => {
        console.error('Failed to delete report:', error);
      });
  };
  const isMobileView = useMediaQuery('(max-width:1024px)');
 


  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                     {loading && (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',position:'fixed',top:0,width:'100%',background:'#000000ab',zIndex:'9999',left:'0' }}>
        <CircularProgress /> {/* Show circular progress loader while loading is true */}
      </div>
    )}
       {progress >0 && progress < 100 && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Loading... {progress}%
          </Typography>
          <Box sx={{ width: "50%", marginY: 2 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Typography variant="body2" color="textSecondary">
            {status}
          </Typography>
        </Box>
      )}
      <Grid container  justifyContent={'space-between'} alignItems={'center'} style={{ display: 'flex' }}>
        <Grid item >
           <Typography style={{ color: '#1C1C1C', fontSize: '16px', fontWeight: 600 }}>{formatBusinessName(breadcrumb)}</Typography>
           
        </Grid>
        {iconsVisible && (
          <Grid item marginTop={1}>
             {isMobileView ? (
               <IconButton
                 onClick={handleGenerateReport}
                 sx={{
                   backgroundColor: '#002060',
                   color: '#ffffff',
                   borderRadius: '8px',
                   width: '40px',
                   height: '40px',
                   '&:hover': {
                     backgroundColor: '#001a4e',
                   },
                   boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                 }}
               >
                 <AddIcon sx={{ fontSize: 22 }} />
               </IconButton>
            ) : (
              <Button
                variant="contained"
                style={{ backgroundColor: '#002060',display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',  marginLeft: '990px',}}
                onClick={handleGenerateReport}
              >
                Generate Report
              </Button>
              
            )}
          </Grid>
        )}



<>

     </>
      </Grid>
      <Grid container style={{ padding: '5px 2px 10px  ' }} alignItems={'center'} justifyContent={'space-between'}>
                  <Grid item >
                  {isMobileView ? (
                    <Typography style={{fontSize:"12px",fontWeight:400,color:"#8C8C8C"}}>
                    Get insights quickly with your Reports
                    </Typography>
                  ) : (
           
                  null
                  )}
                  </Grid>
      </Grid>
      <hr style={{ margin: '1px 0', borderColor: '#0000001A' }} />
      <ReportGen
  open={openReportGenModal}
  onClose={() => setOpenReportGenModal(false)}
  initialOption={initialOption}

  onGenerateReport={handleGenerateReportData}
  reportData={reportGenInitialValues}
  viewedReportData={viewedReportData} 
/>
    
     
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
      {reportDataByYear.annualReports && Object.keys(reportDataByYear.annualReports).length > 0 && (
  <>
    {Object.keys(reportDataByYear.annualReports).map((year) => (
      <div key={year} style={{ margin: '20px', display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={() => handleToggleExpand(year)}>
                  <ExpandMoreIcon />
                </IconButton>
          <Typography variant="h6" gutterBottom style={{ marginLeft: '10px' }}>{year}</Typography>
        </div>
        {expandedYears[year] && (
          <Grid container spacing={2}>
            {reportDataByYear.annualReports[year]?.map((reportData, index) => (
              <Grid item key={index} xs={12} sm={6} md={4} lg={3} xl={3}>
             

                <AnnualReportCard
                  key={index}
                  reportData={reportData}
                  setLoadingpdf={setLoading}
                  setProgresspdf={setProgress}
                  setStatuspdf={setStatus}
                  onEditClick={handleCardClick}
                  activeTab={activeTab}
                  onViewTabChange={setActiveTab}
                  onDeleteClick={handleDeleteReport}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    ))}
  </>
)}




{reportDataByYear.customReports && reportDataByYear.customReports.length > 0 && (
      <div style={{ margin: '20px', display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={() => handleToggleExpand('customReports')}>
            <ExpandMoreIcon />
          </IconButton>
          <Typography variant="h5" gutterBottom style={{ marginLeft: '10px' }}>Custom Reports</Typography>
        </div>
        {expandedYears['customReports'] && (
          <>
            <Grid container spacing={2}>
              {reportDataByYear.customReports.slice(0, visibleReportsCount).map((reportData, index) => (
                <Grid item key={index} xs={12} sm={6} md={4} lg={3} xl={3}>
                  
                  <AnnualReportCard
                    key={index}
                    reportData={reportData}
                    setLoadingpdf={setLoading}      // Pass the correct prop
                    setProgresspdf={setProgress}    // Pass the correct prop
                    setStatuspdf={setStatus}        // Pass the correct prop
                    onEditClick={handleCardClick}
                    activeTab={activeTab}
                    onViewTabChange={setActiveTab}
                    onDeleteClick={handleDeleteReport}
                  />
                </Grid>
              ))}
            </Grid>
            {reportDataByYear.customReports.length > visibleReportsCount && (
              <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 3, mb: 1 }}>
                <Button 
                  variant="outlined" 
                  onClick={() => setVisibleReportsCount(prev => prev + 10)}
                  sx={{
                    color: '#002060',
                    borderColor: '#002060',
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '13px',
                    fontFamily: 'var(--app-font)',
                    '&:hover': {
                      borderColor: '#001a4e',
                      backgroundColor: '#f1f5f9',
                    }
                  }}
                >
                  Load More (showing {visibleReportsCount} of {reportDataByYear.customReports.length})
                </Button>
              </Box>
            )}
          </>
        )}
      </div>
    )}

       
      </div>
    </div>
  );
        }